import { ModuleProduct } from "../../ModuleProduct";
import { fontTtfDataUrl } from "./font";
import { svgElem, dropShadow, svgRect } from "../../svg/elements";
import { fixCase, transformTextEnclosure } from "../../svg/modify";
import { Warp } from "../../svg/Warp";
import svgPathBbox from "svg-path-bbox";
import { Region } from "../../../types";
import { _loadFontExternalDataURL } from "../../../util/font";

export class Vegemite extends ModuleProduct {
    moduleName = "Vegemite";

    svgPreview(text: string, region: Region): string {
        return this.svgElement(text, region);
    }

    svgPrint(text: string, region: Region): string {
        return this.svgElement(text, region);
    }

    private svgElement(text: string, region: Region): string {
        const font = _loadFontExternalDataURL(fontTtfDataUrl);
        const capitalise = (word: string): string => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
        const parsedtext = text !== "" ? capitalise(text) : "";
        const basePath = font.getPath(parsedtext, 0, 72, 72);
        const pathSvg = basePath.toSVG(2);

        const box = basePath.getBoundingBox();
        const pathWidth = box.x2 - box.x1;
        const pathData = basePath.toPathData(3);

        const textSvg = (): SVGElement => {
            const g = svgElem("g");
            g.classList.add("module-text-group");
            const gdefs = svgElem("defs");
            g.appendChild(gdefs);
            gdefs.appendChild(dropShadow(0, 2, 2, "shadow"));

            const thick = svgElem("path");
            thick.setAttribute("d", pathData);
            thick.setAttribute("stroke", "black");
            thick.setAttribute("stroke-width", "3");
            gdefs.appendChild(thick);

            const layer0 = svgElem("g");
            layer0.classList.add("module-layer0");
            g.appendChild(layer0);
            layer0.setAttribute("filter", "url(#shadow)");
            layer0.innerHTML = thick.outerHTML;

            const layer1 = svgElem("g");
            layer1.classList.add("module-layer1");
            g.appendChild(layer1);
            layer1.setAttribute("stroke-width", "3");
            layer1.setAttribute("stroke", "rgb(45,41,38)");
            layer1.setAttribute("fill", "rgb(45,41,38)");
            layer1.setAttribute("transform", "translate(0.5,0)");
            layer1.innerHTML = pathSvg;

            const layer2 = svgElem("g");
            layer2.classList.add("module-layer2");
            g.appendChild(layer2);
            layer2.setAttribute("fill", "rgb(255,209,0)");
            layer2.setAttribute("transform", "translate(1,-0.1)");
            layer2.innerHTML = pathSvg;

            const layer3 = svgElem("g");
            layer3.classList.add("module-layer3");
            g.appendChild(layer3);
            layer3.setAttribute("fill", "white");
            layer3.innerHTML = pathSvg;

            const warp = new Warp(g);
            warp.transform(([x, y]) => [x, y + (pathWidth / 2 - x) ** 2 / (pathWidth * 6)]); // Curve down from center
            return g;
        };

        const rootElement = svgElem("g");
        rootElement.classList.add("module-root");

        const defs = svgElem("defs");
        rootElement.appendChild(defs);

        const bounds = svgElem("g");
        bounds.classList.add("module-bounds");
        rootElement.appendChild(bounds);
        const boundsRect = svgRect(region.height, region.width);
        boundsRect.setAttribute("opacity", "0");
        bounds.appendChild(boundsRect);

        const textEnclosure = svgElem("g");
        textEnclosure.classList.add("module-text-enclosure");
        rootElement.appendChild(textEnclosure);

        const textGroup = textSvg();
        textEnclosure.appendChild(textGroup);

        const textBbox = svgPathBbox(pathData);
        transformTextEnclosure(textEnclosure, textBbox, region.height, region.width, 0.35, 0.65);

        return fixCase(rootElement.outerHTML);
    }
}
